module.exports = __webpack_public_path__ + "img/product2.ff638965.jpeg";